import { TileLayout } from '@progress/kendo-react-layout';
import { useEffect, useRef, useState } from 'react';
import { useLocalization } from '@progress/kendo-react-intl';
import { Devices } from '../components/dashboard/Devices';
import { AlarmsTile } from '../components/dashboard/AlarmsTile';
import { DevicesBatteryStatus } from '../components/dashboard/DevicesBatteryStatus';
import { Alarms } from './Alarms';
import { DevicesTileCounter } from '../components/dashboard/DevicesTileCounter';
import { RegularTag } from '../components/dashboard/RegularTag';
import { AccessToken } from '../config/AccessToken';
import axios from 'axios';


export const Dashboard = ((props: any) => {

  const accountId = localStorage.getItem('accountId');
  const languageId = localStorage.getItem('languageId');
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [instance, accessTokenRequest] = AccessToken();

  const [error, setError] = useState('');

  const localizationService = useLocalization();

  const userEmail = localStorage.getItem('email');

  const valueRegularTag: any = localStorage.getItem('regularTag') ?? 5;

  let initialTiles: any = [
    {
      id: 0,
      defaultPosition: { col: 1, colSpan: 2, rowSpan: 1, order: 1 },
      header: localizationService.toLanguageString('dashboard.widget.devices.title', 'NOT_FOUND'),
      body:
        <Devices />,
      resizable: false,
      visible: true
    },
    {
      id: 1,
      defaultPosition: { col: 3, colSpan: 1, rowSpan: 1, order: 2 },
      header: localizationService.toLanguageString('dashboard.widget.devices_counter', 'NOT_FOUND'),
      body:
        <DevicesTileCounter />,
      resizable: false,
      visible: true
    },
    {
      id: 2,
      defaultPosition: { col: 4, colSpan: 1, rowSpan: 1, order: 3 },
      header: localizationService.toLanguageString('dashboard.widget.alarms_counter', 'NOT_FOUND'),
      body:
        <AlarmsTile />,
      resizable: false,
      visible: true
    },
    {
      id: 3,
      defaultPosition: { col: 5, colSpan: 2, rowSpan: 1, order: 4 },
      header: localizationService.toLanguageString('dashboard.widget.regular_tag', 'NOT_FOUND') + ` (${valueRegularTag}H)`,
      body:
        <RegularTag />,
      resizable: false,
      visible: true
    },
    {
      id: 4,
      defaultPosition: { col: 7, colSpan: 3, rowSpan: 2, order: 5 },
      header: localizationService.toLanguageString('dashboard.widget.devices.battery_status', 'NOT FOUND'),
      body:
        <DevicesBatteryStatus
          rowSpan={2}
          colSpan={3}
        />,
      resizable: false,
      visible: true
    },
  ];

  const [tiles, setTiles] = useState(() => {
    return initialTiles
  });

  useEffect(() => {
    // Save updated tile positions to localStorage
    saveTilesToLocalStorage(tiles)
  }, [tiles]);

  const saveTilesToLocalStorage = (tiles: any[]) => {

    const tileStateToSave: any = tiles.map(({ id, header, defaultPosition, resizable, visible }) => ({
      id,
      header,
      defaultPosition,
      resizable,
      visible,
    }));
    localStorage.setItem(`tileState: ${userEmail}`, JSON.stringify(tileStateToSave));
  };


  const handleLayoutChange = (event: any) => {
    //console.log('Layout Change Event:', event);

    const reorderedVisibleTiles = event?.value?.map((item: any) => {
      // Try to use order as a fallback if id is missing
      const currentTile = tiles.find((tile: any) =>
        tile.id === item.id || tile.defaultPosition.order === item.order
      );

      return currentTile ? {
        ...currentTile,
        header: currentTile.header,
        defaultPosition: {
          col: item.col,
          colSpan: item.colSpan,
          rowSpan: item.rowSpan,
          order: item.order,
        },
      }
        : null;
    })
      .filter((tile: any) => tile !== null); // Filter out any null values

    const updatedTiles: any = tiles.map((tile: any) => {
      const reorderedTile = reorderedVisibleTiles.find((t: any) => t.id === tile.id);
      return reorderedTile ? reorderedTile : tile; // Keep hidden tiles as they were
    });

    setTiles(updatedTiles); // Set and save state immediately after reordering
    saveTilesToLocalStorage(updatedTiles); // Save immediately
  };


  const updateClientConfig = async () => {

    const params = {
      settings: [{
        id: 'Language',
        group: 'VIE',
        description: 'Smart Locator Language',
        value: languageId == 'it-IT' ? '1' : '0',
        clientId: Number(accountId) ?? ''
      }]
    };

    const commonOperations = async (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };

      try {
        await axios.put(`${SERVER_URL}/settings/Client`, params, { headers })
      } catch (error: any) {
        console.error("Errore:", error);
      }
    }

    if (localStorage.getItem('accessToken') != null) {
      let accessToken = localStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.acquireTokenSilent(accessTokenRequest).then(async (accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken)
      })
    }
  }

  useEffect(() => {
    updateClientConfig()
  }, [])

  return (
    <div
      style={{ backgroundColor: '#f7f7f7' }}
    >
      {error && <p className="text-danger" style={{ zIndex: 999, position: 'relative', width: '65%' }}>{error}</p>}
      
      <TileLayout
        columns={9}
        items={
          tiles?.filter((tile: any) => tile.visible)?.map((tile: any) => ({
            id: tile.id, // Attach 'id' explicitly here
            header: tile.header,
            defaultPosition: tile.defaultPosition,
            body: tile.body,
            resizable: tile.resizable
          }))}
        rowHeight={230}
        gap={{ rows: 10, columns: 5 }}
        //columnWidth={200}
        //autoFlow={"row dense"}
        //onReposition={handleLayoutChange}
        ignoreDrag={() => true}
        style={{ backgroundColor: '#f7f7f7', color: 'white' }}
      />
      <br />
      <div style={{ borderTop: '1px solid white' }} />
      <br />
      <h1 style={{ textAlign: 'center', color: '#1A8A95' }}>{localizationService.toLanguageString('dashboard.last_active_alarms', 'NOT FOUND')}</h1>
      <br />
      <Alarms preview='preview' />
    </div>
  );
});


